import { render, staticRenderFns } from "./YoukeLaiyuanFenxi.vue?vue&type=template&id=0f237af3&scoped=true&"
import script from "./YoukeLaiyuanFenxi.vue?vue&type=script&lang=js&"
export * from "./YoukeLaiyuanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f237af3",
  null
  
)

export default component.exports